import { Component, OnInit, ViewChild } from '@angular/core';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { IndustryReportsService, BrandCountResponse } from 'src/app/services/industry-reports.service';
import { LabelValue } from 'src/app/models/common.model';
import { BrandIdReportRequestPayload, BrandIdReport, BrandIdReportResponse } from 'src/app/models/industry-reports.model';
import { TableColumn } from 'src/app/models/table-columns';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';
import { ShortCodesService } from 'src/app/services/shortcodes.service';
import { ScrBaseService } from 'src/app/services/base.service';

import { Table } from 'primeng/table';

@Component({
  selector: 'app-brand-identification',
  templateUrl: './brand-identification.component.html',
  styleUrls: ['./brand-identification.component.scss']
})
export class BrandIdentificationComponent extends ScrBaseComponent implements OnInit {

  @ViewChild('brandIdTable', { static: false }) brandIdTable?: Table;

  statusList = [
    { label: 'Dedicated', value: 'Dedicated' },
    { label: 'Unverified', value: 'Unverified' },
    { label: 'Shared', value: 'Shared' },
    { label: 'Unknown', value: 'Unknown' }
  ];
  tableColumn: TableColumn[] = [
    { field: 'shortCode', width: '7' },
    { field: 'status', width: '8' },
    { field: 'contentProvider' },
    { field: 'brands' },
    { field: 'verticals' },
    { field: 'campaignTypes' }
  ];
  displayFilter = false;
  displayReport = false;
  verticalList: LabelValue<string, string>[] = [];
  enteredShortCode = '';
  public brandCountResponse?: BrandCountResponse;
  identificationPayload: BrandIdReportRequestPayload = {} as BrandIdReportRequestPayload;
  brandIdResponse: BrandIdReportResponse = {} as BrandIdReportResponse;
  brandResponse: BrandIdReport[] = [];
  shortCodeFilter = '';
  totalRecords = 0;
  currentPage = 0;
  invalidShortCode = '';
  rowsInPage = 0;
  first = 0;

  constructor(private industryReportsService: IndustryReportsService, private router: Router, private scService: ShortCodesService) {
    super();

  }
  ngOnInit(): void {
    this.localizeTableColumns(this.tableColumn);

    this.identificationPayload.verticals = [];
    this.industryReportsService.getBrandIdentificationFilters().subscribe(res => {
      this.brandCountResponse = res;

      // reassigned here so that PrimeNG knows that it changed.
      this.identificationPayload.verticals = [];
      this.verticalList.push({ label: 'No Verticals', value: 'No Verticals' });
      this.identificationPayload.verticals.push('No Verticals');
      this.brandCountResponse.data.verticals.forEach(vertical => {
        this.verticalList.push({ label: vertical, value: vertical });
        this.identificationPayload.verticals.push(vertical);
      });

      this.identificationPayload.statuses = this.statusList.map(item => item.value);
      this.displayFilter = true;
    });
  }
  onReset() {
    this.shortCodeFilter = '';
    this.identificationPayload = {} as BrandIdReportRequestPayload;
    this.identificationPayload.statuses = this.statusList.map(item => item.value);
    this.identificationPayload.verticals = this.verticalList.map(item => item.value);
    this.enteredShortCode = '';
  }

  onDownload(): void {
    this.industryReportsService.downloadBrandIdentificationHistory().subscribe({
      next: (res) => {
        this.industryReportsService.processBlobResponseDownload(res, 'text/csv');
      },
      error: (error: HttpErrorResponse) => {
        this.processHttpScrErrorResponse(error); this.jumpToTop();
      }
    });
  }

  onSubmit() {
    this.clearMessages();
    if (!this.isValidShortCodes()) {
      this.displayLocalizedError('scr.shortcodes.invalid', { invalidShortCode: this.invalidShortCode });
      this.brandResponse = [];
    }
    else {
      this.identificationPayload.page = 1;
      this.identificationPayload.sort = "ASC";
      this.observe(this.industryReportsService.generateBrandIdentificationReport(this.identificationPayload), res => {
        if (res.data) {
          this.rowsInPage = res.data.limit;
          this.brandResponse = res.data.content;
          this.displayReport = true;
          this.totalRecords = res.data.totalCount;
        }
        else {
          this.log.warn('brand identification report contains no data');
        }
        return false;
      });
      if (this.enteredShortCode !== "")
        this.resetSearchWithShortCodes();

    }
  }

  resetSearchWithShortCodes() {
    this.identificationPayload.statuses = [];
    this.identificationPayload.statuses = this.statusList.map(item => item.value);
    this.identificationPayload.verticals = [];
    this.identificationPayload.verticals = this.verticalList.map(item => item.value);
    this.identificationPayload.brand = '';
    this.identificationPayload.contentProvider = '';
  }

  isValidShortCodes(): boolean {
    let isValid = true;
    this.invalidShortCode = '';
    this.identificationPayload.shortCodes = [];
    if (this.enteredShortCode === "")
      isValid = true;
    else {
      const codes = this.enteredShortCode.trim().split("\n");
      codes.forEach(element => {
        if (element.length < 5 || ScrBaseService.isInvalidShortCode(element)) {
          isValid = false;
          if (this.invalidShortCode.length > 0) {
            this.invalidShortCode += ',' + element;
          }
          else {
            this.invalidShortCode += element;
          }
        }
        else {
//          !isValid ? isValid = false : isValid = true;
          this.identificationPayload.shortCodes?.push(ScrBaseService.shortCodeToNumeric(element));
        }
      });
    }
    return isValid;
  }

  loadLazyBrandId(event: LazyLoadEvent) {
    this.currentPage = (event.first ?? 0) / (event.rows ?? 0) + 1;
    this.identificationPayload.page = this.currentPage;
    this.identificationPayload.sort = "ASC";
    this.isValidShortCodes();

    this.observe(this.industryReportsService.generateBrandIdentificationReport(this.identificationPayload), res => {
      if (res.data) {
        this.brandResponse = res.data.content;
        this.brandResponse = res.data.content;
        this.displayReport = true;
        this.totalRecords = res.data.totalCount;
      }
      else {
        this.log.warn('brand identification report contains no data');
      }
      window.scroll(0, 100);
    });
  }


  // Only Integer Numbers
  keyPressNumbers(event: Event) {

    if (this.enteredShortCode.length > 33) {
      event.preventDefault();
      return false;
    }
    const codes = this.enteredShortCode.split("\n");
    let count = 0;
    codes.forEach(element => {
      count++;
      if (element.length === 6 && count === codes.length)
        this.enteredShortCode = this.enteredShortCode + "\n";
      return;
    });
    return true;
  }

  navigateLookup(report: BrandIdReport) {
    this.router.navigate(['/dashboard', { outlets: { 'navbar-tab': ['code-management', { outlets: { 'code-management-tab': ['code-lookup'] } }] } }], { state: { shortCode: report.shortCode } });
  }
}
